const styles = `:host {
  height: 4px;
  width: 100%;
}
:host .progress,
:host .determinate,
:host .indeterminate {
  border-radius: 2px;
}
:host .progress {
  background-color: var(--goto-ui-05);
}
:host .determinate {
  background-color: var(--goto-interactive-01);
}
:host .indeterminate-indicator-1,
:host .indeterminate-indicator-2 {
  background-color: var(--goto-interactive-01);
}

:host([size=large]) {
  height: 8px;
}
:host([size=large]) .progress,
:host([size=large]) .determinate,
:host([size=large]) .indeterminate {
  border-radius: 4px;
}

:host([inverse]) .progress {
  background-color: var(--goto-inverse-ui-05);
}
:host([inverse]) .determinate {
  background-color: var(--goto-inverse-interactive-01);
}
:host([inverse]) .indeterminate-indicator-1,
:host([inverse]) .indeterminate-indicator-2 {
  background-color: var(--goto-inversed-interactive-01);
}`; export default styles;